'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Definition of colors for the Xactly UI.
 */
exports['default'] = {
  xValidation: '#F76321',
  xSuccess: '#79C45F',
  xAlert: '#D0011B',
  xCore: '#346F8F',
  xSky: '#64ADC2',
  xGreenery: '#9BC77B',
  xSunshine: '#FDB913',
  xPlum: '#6C0049',
  xSoothe: '#637399',
  xBalm: '#B1D7DF',
  xCoal: '#333333',
  xCoalModerate: '#666666',
  xCoalLight: '#999999',
  xGreyDark: '#CCCCCC',
  xGrey: '#E5E5E5',
  xGreyLight: '#E7E7E7',
  xPure: '#FFFFFF',
  xSootheLight: '#EEF3F6',
  xGrounded: '#003749',
  xGroundedModerate: '#E4E6E8',
  xGroundedLight: '#F6F7F8',
  xUrgent: '#EC354B',
  xLively: 'linear-gradient(to bottom right, #6F7B9D, #67A2C2)'
};